const styles = {
  schoolTitle: {
    textAlign: 'center',
    margin: '0'
  },
  navContianer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    left: '0',
    bottom: '0',
    width: '100%'
  }
}

export default styles
